import React from 'react';
import { Button, Form, Checkbox } from 'semantic-ui-react';
import styled from "styled-components";
import { ErrorMessage } from "formik";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const checkBoxLbl = {
    'stp5_consentPermission': `I give permission for Pay Justice and Roscoe Reid 
            to retain my information with the purpose of processing my claim 
            against Boots for equal pay. I further give permission to Roscoe Reid 
            to their providing my information to barristers, 
            experts, the claimant committee, funders and insurers, tribunals and 
            courts, and to the Boots group of companies and their legal 
            representatives as necessary for the purposes of the claim.`,

    'stp5_consentPrivacy': `I accept that Pay Justice or Roscoe Reid may contact me regarding 
            this claim. More information about our Privacy Policy can be found on our website.`,

    'stp5_consentIdentity': `I agree that Pay Justice may send the information I have provided 
            to Onfido to complete an identity check.`
}

class ConsentForm extends React.Component<any, any> {

    prev = (e: any) => {
        e.preventDefault();
        this.props.prevStep();
    }

    next = (e: any) => {
        e.preventDefault();
        this.props.gaEvent('event', 'AcceptTerms', 'Next', 'Boots', this.props.isValid);
        this.props.nextStep(this.props);
    }

    render() {
        return (
            <React.Fragment>
                <Form.Group grouped>

                    <label>
                        Please confirm that you agree to the following in order for us to continue with your claim.
                    </label>

                    <div className="ui divider"></div>

                    <Form.Field>
                        <Checkbox
                            name='stp5_consentPermission'
                            label={checkBoxLbl.stp5_consentPermission}
                            checked={this.props.values.stp5_consentPermission}
                            onChange={(e, { name, checked }) => this.props.setFieldValue(name, checked)}
                            data-testid="cf-checkbox-permission"
                        />
                        <ErrorMessage
                            name={'stp5_consentPermission'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Field>

                    <div className="ui divider"></div>

                    <Form.Field>
                        <Checkbox
                            name='stp5_consentPrivacy'
                            label={checkBoxLbl.stp5_consentPrivacy}
                            checked={this.props.values.stp5_consentPrivacy}
                            onChange={(e, { name, checked }) => this.props.setFieldValue(name, checked)}
                            data-testid="cf-checkbox-privacy"
                        />
                        <ErrorMessage
                            name={'stp5_consentPrivacy'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Field>

                    <div className="ui divider"></div>

                    <Form.Field>
                        <Checkbox
                            name='stp5_consentIdentity'
                            label={checkBoxLbl.stp5_consentIdentity}
                            checked={this.props.values.stp5_consentIdentity}
                            onChange={(e, { name, checked }) => this.props.setFieldValue(name, checked)}
                            data-testid="cf-checkbox-identity"
                        />
                        <ErrorMessage
                            name={'stp5_consentIdentity'}
                            render={msg => <RedText className="error"> {msg} </RedText>}
                        />
                    </Form.Field>

                    <div className="ui divider"></div>

                    <Button.Group widths="2">
                        <Button labelPosition='left' floated='left' color="grey" icon='left chevron' content='Back' onClick={this.prev} data-testid="cf-button-back" />
                        <Button labelPosition='right' floated='right' color={this.props.isValid ? 'green' : 'grey'} icon='right chevron' content='Next' onClick={this.next} data-testid="cf-button-next" />
                    </Button.Group>

                </Form.Group>
            </React.Fragment>
        );
    }
}

export default ConsentForm;